import React from 'react';

type IconCloseCircleProps = {
    className?: string;
};

export function IconCloseCircle(props: IconCloseCircleProps) {
    const { className = '' } = props;

    return (
        <svg
            className={`${className}`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke="#000000"
                d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path stroke="#000000" d="M11 5L5 11" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path stroke="#000000" d="M5 5L11 11" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default IconCloseCircle;
